module.exports = __webpack_public_path__ + "static/media/indonesia-flag.a1bd5d2e.svg";